import { useCallback, useRef } from 'react';
import { api } from '@/lib/trpc/client';
import { ProjectList } from './project-list';

const PER_PAGE = 4;

export function WorksInfiniteList() {
	const [{ pages }, { fetchNextPage, hasNextPage, isFetchingNextPage }] =
		api.project.list.useSuspenseInfiniteQuery(
			{ perPage: PER_PAGE },
			{
				initialCursor: 1,
				getNextPageParam: (last, all) =>
					last.length === PER_PAGE ? all.length + 1 : undefined,
			},
		);

	const observer = useRef<IntersectionObserver>(null);
	const sentinelRef = useCallback(
		(el: HTMLDivElement | null) => {
			observer.current?.disconnect();
			if (!el || !hasNextPage || isFetchingNextPage) return;
			observer.current = new IntersectionObserver(([entry]) => {
				if (entry?.isIntersecting) fetchNextPage();
			});
			observer.current.observe(el);
		},
		[hasNextPage, isFetchingNextPage, fetchNextPage],
	);

	const projects = pages.flat();

	return (
		<div className="flex flex-col gap-8">
			<ProjectList projects={projects} />
			<div ref={sentinelRef} className="h-4" />
			{isFetchingNextPage && (
				<div className="flex justify-center py-8">
					<div className="size-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
				</div>
			)}
		</div>
	);
}
